<template>
  <div class="row mt-4 mb-4">
    <div class="col"></div>
    <div class="col-11 col-sm-8 col-md-6 col-lg-5 col-xl-4 text-left">
      <h2 class="sr-only">Login</h2>
      <form>
        <div class="form-group">
          <label for="loginEmail">{{ $t('login-form-email-label') }}</label>
          <select class="custom-select" id="loginEmail" v-model="selectedLoginEmail" :disabled="signedUser !== undefined">
            <option v-for="existingUser of existingUsers" :key="existingUser.id" :class="{ 'selected': existingUser.id === signedUser }">{{ existingUser.name }}</option>
          </select>
          <!--
          <input type="email" class="form-control" id="loginEmail" aria-describedby="emailHelp" placeholder="Enter email">
          -->
        </div>
        <div class="form-group" v-if="signedUser === undefined">
          <label for="loginPassword">{{ $t('login-form-password-label') }}</label>
          <input type="password" class="form-control" id="loginPassword" placeholder="Unused Password (demo)">
        </div>
        <a class="btn btn-primary" v-if="signedUser === undefined" v-on:click="signUser">{{ $t('login-form-login-button') }}</a>
        <a class="btn btn-primary" v-if="signedUser !== undefined" v-on:click="logoutUser">{{ $t('login-form-logout-button') }}</a>
      </form>
    </div>
    <div class="col"></div>
  </div>
</template>

<script>
export default {
  name: "LoginForm",
  data() {
    return {
      existingUsers: [
        { name: 'frederic.deuze@orange.com', id: 'dzaodxzzxozxzx' },
        { name: 'guillaume.jourdain@orange.com', id: 'szaxpza12763' },
        { name: 'lionel.tailhardat@orange.com', id: 'szaodkocz' },
        { name: 'jixiong.liu@orange.com', id: 'psaoskaz' },
        { name: 'viet-phi.huynh@eurecom.fr', id: 'wxazxsqx878' },
        { name: 'pierre.monnin@orange.com', id: 'SDSRZA9863' },
        { name: 'raphael.troncy@eurecom.fr', id: 'pdzoazkd' },
        { name: 'thomas.labbe@orange.com', id: 'xzexreztyxaz' },
        { name: 'yoan.chabot@orange.com', id: 'xazxezkxok' },      
        { name: 'christophe.sarthoucamy@orange.com', id: 'zxxczec' }
      ],
      selectedLoginEmail: undefined
    };
  },
  mounted() {
  },
  computed: {
    signedUser: function() {
      return (this.$store.state.identityIdentified !== undefined) ? this.$store.state.identityIdentified.email : undefined;
    }
  },
  methods: {
    signUser() {
      if (this.selectedLoginEmail !== undefined) {
        this.$store.commit('login', { email: this.selectedLoginEmail });
      } else {
        console.log('[LoginForm] [signUser] this.selectedLoginEmail is undefined');        
      }
    },
    logoutUser() {
      this.$store.commit('logout');
    }
  }
}
</script>

<style scoped>

</style>